import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const Wordmark = ({ dark }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
    <img src="/logo.png" alt="The Ditch Careers" data-testid="site-logo" className="h-9 w-9 rounded-full object-contain" />
    <span className="flex items-baseline gap-1.5">
      <span className={`font-heading font-bold text-lg tracking-tight ${dark ? "text-white" : "text-[#0d2f4d]"}`}>
        The Ditch
      </span>
      <span className={`font-accent text-xl ${dark ? "text-[#C1CC24]" : "text-[#0d2f4d]"} underline decoration-[#C1CC24] decoration-4 underline-offset-[3px]`}>
        Careers
      </span>
    </span>
  </Link>
);

export const PublicHeader = ({ hideCandidateCta = false }) => {
  const { user } = useAuth();
  const navCls = ({ isActive }) =>
    `text-sm font-medium transition-colors hover:text-[#7C8514] ${isActive ? "text-[#7C8514]" : "text-[#0d2f4d]"}`;
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#fcfbf8]/80 backdrop-blur-xl border-b border-[#e3e0d3]/60">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Wordmark />
        <nav className="hidden sm:flex items-center gap-8">
          <NavLink to="/candidates" className={navCls} data-testid="nav-candidates">Candidates</NavLink>
          <NavLink to="/jobs" className={navCls} data-testid="nav-jobs">Jobs</NavLink>
          <NavLink to="/employers" className={navCls} data-testid="nav-employers">Employers</NavLink>
          <NavLink to="/team" className={navCls} data-testid="nav-team">Meet the team</NavLink>
        </nav>
        {user && user !== false ? (
          <Link to={user.role === "candidate" ? "/candidate" : "/employer"} data-testid="nav-dashboard"
            className="rounded-full bg-[#0d2f4d] text-white text-sm font-medium px-5 py-2 hover:bg-[#1c4d78] transition-colors">
            My Dashboard
          </Link>
        ) : (
          <div className="flex items-center gap-3">
            <Link to="/signin" data-testid="nav-signin"
              className="text-sm font-medium text-[#0d2f4d] hover:text-[#7C8514] transition-colors">Sign in</Link>
            {!hideCandidateCta && (
              <Link to="/candidates" data-testid="nav-cta-candidate"
                className="rounded-full bg-[#C1CC24] text-[#0d2f4d] text-sm font-semibold px-4 py-2 hover:bg-[#aeb81f] transition-colors">
                I'm a Candidate
              </Link>
            )}
            <Link to="/employers" data-testid="nav-cta-employer"
              className="hidden sm:inline-flex rounded-full border border-[#0d2f4d] text-[#0d2f4d] text-sm font-medium px-4 py-2 hover:bg-[#0d2f4d] hover:text-white transition-colors">
              I'm an Employer
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};
